export function applicableProfiles ({ aufschaltung, navigation: {category, api, app} }) {
  if (category === 'api') {
    const _api = findApi({aufschaltung}, {nickname: api})
    return aufschaltung.profiles.filter(profile => _findFeed({aufschaltung}, {profile: profile, api: _api}))
  }
  return []
}

export function findJsonFeedForProfile (context) {
  const feed = findFeed({
    aufschaltung: context.aufschaltung,
    navigation: {
      profile: context.navigation.profile,
      api: 'jsonfeed' }})
  return feed
}

export function findGraphqlApikpFeedForProfile (context) {
  const feed = findFeed({
    aufschaltung: context.aufschaltung,
    navigation: {
      profile: context.navigation.profile,
      api: 'graphqlapikp' }})
  return feed
}

export function findFeedsForApi (context, api) {
  const aufschaltung = context.aufschaltung
  const _api = findApi({aufschaltung}, {nickname: api})
  let feeds = aufschaltung.profiles.map((_profile) => {
    return _findFeed({aufschaltung}, {profile: _profile, api: _api})
  })
  feeds = feeds.filter(f => f)
  return feeds
}

export function findFeedInContext (aufschaltung, profile, api) {
  if (profile) {
    const feed = aufschaltung.feeds.find(_feed => _feed.profile_id === profile.id)
    return feed
  }
  if (api) {
    const feed = aufschaltung.feeds.find(_feed => {
      return (
        _feed.api_id === api.id
      )
    })
    return feed
  }
}

export function findFeed ({ aufschaltung, navigation: {profile, api} }) {
  // navigation.profile and navigation.api are nicknames, resolve them
  const _profile = findProfile({aufschaltung}, {nickname: profile})
  const _api = findApi({aufschaltung}, {nickname: api})
  if (!_profile || !_api) {
    return null
  }
  return _findFeed({aufschaltung}, {profile: _profile, api: _api})
}

function _findFeed ({aufschaltung}, {profile, api}) {
  const feed = aufschaltung.feeds.find(f => {
    return (profile === null || f.profile_id === profile.id) &&
      (api === null || f.api_id === api.id)
  })
  return feed
}

export function hasApiIdPattern ({aufschaltung, navigation: {profile_nickname, api_id_pattern}}) {
  const profile = findProfile({aufschaltung}, {nickname: profile_nickname})
  // check whether given profile api matches pattern
  if (profile) {
    const feed = aufschaltung.feeds.find(f => {
      return (profile === null || f.profile_id === profile.id)
    })
    return feed ? feed.api_id.indexOf(api_id_pattern) !== -1 : false
  }

  // no profile given - check for api pattern in feeds
  return aufschaltung ? aufschaltung.apis.find((api) => {
    return api ? api.id.indexOf(api_id_pattern) !== -1 : false
  }) : false
}

export function findProfile ({aufschaltung}, {nickname}) {
  return aufschaltung ? aufschaltung.profiles.find(profile => profile.nickname === nickname) : null
}

export function findApi ({aufschaltung}, {nickname}) {
  return aufschaltung ? aufschaltung.apis.find(api => api.nickname === nickname) : null
}

export function findApp ({aufschaltung}, {nickname}) {
  return aufschaltung ? aufschaltung.apps.find(app => app.nickname === nickname) : null
}



// WEBPACK FOOTER //
// ./src/all_cards/aufschaltung.js